export default "__VITE_ASSET__BkitFufT__"